import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BankAccountsService, ProviderCredential } from 'src/app/shared/services/bank-accounts.service';

@Component({
  selector: 'app-provider-credential-list',
  templateUrl: './provider-credential-list.component.html',
  styleUrls: ['./provider-credential-list.component.scss']
})
export class ProviderCredentialListComponent implements OnInit {
  loading: boolean = true;
  noCredsFound: boolean = false;
  credentials: ProviderCredential[] = new Array<ProviderCredential>();

  constructor(private bankAccSvc: BankAccountsService, private router: Router) {

  }
  ngOnInit(): void {
    this.loading = true;
    this.noCredsFound = false;
    this.bankAccSvc.getProviderCredentials()
      .subscribe({
        next: (data: ProviderCredential[]) => {
          this.credentials = data;
        },
        error: (err: HttpErrorResponse) => {
          console.log(err);
          if (err.status === 404 && err.error === "No provider credentials found.") {
            this.noCredsFound = true;
            this.loading = false;
            this.router.navigate(['/bank/accounts/providers/credentials/add'], {queryParams:{'from':'credsList', 'noCreds':true}});
          }
        },
        complete: () => {
          this.loading = false;
        }
      });
  }
}
